class AccordionList extends HTMLElement {
  constructor() {
    super();
    this.titlesArr = this.querySelectorAll(".accordion-list-item_title");

    this.load();
  }
  load() {
    this.titlesArr.forEach((title) => {
      title.nextElementSibling.style.height = "auto";

      title.nextElementSibling.style.maxHeight =
        title.nextElementSibling.offsetHeight + 350 + "px";
      title.addEventListener("click", (e) => this.showListHandler(e));
      title.closest(".accordion-list__item").classList.add("loaded");
    });
  }
  showListHandler(e) {
    const selectedItem = e.target.closest(".accordion-list__item");
    if (this.dataset.oneOpenedOnly === "true") {
      this.querySelectorAll(".accordion-list__item").forEach((i) => {
        if (i !== selectedItem) i.classList.remove("active");
      });
    }
    selectedItem.classList.toggle("active");
  }
}
customElements.define("accordion-list", AccordionList);
